import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contaPrefixPipe',
  standalone: false,
})
export class ContaPrefixPipe implements PipeTransform {
  transform(texto: string, prefixo: string): string {
    if (texto) {
      //se prefixo for conta, adiciona 'CC ' no inicio da string
      if (prefixo == 'conta') {
        return 'CC  ' + texto;
      }
      //se o prefixo for agencia, adiciona 'AG ' no inicio da string
      if (prefixo == 'agencia') {
        return 'AG ' + texto;
      }
    }

    return texto;
  }
}
